module.exports = __webpack_public_path__ + "img/object_defineProperty_mdn.f95c688b.png";